<template>
	<div>
		<div class="hero sto">
      <div class="inner">
        <h1>{{$t('stoPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('stoPage.text2')}}</h5>
      </div>
    </div>


		<section class="">
      <div class="section-inner">
				<img class="article-image" src="@/assets/images/sto-image1.png" alt="">
        <div class="article-container">
          <h2 v-html="$t('stoPage.text3')"></h2>
          <p>{{$t('stoPage.text4')}}</p>
        </div>
      </div>
    </section>


		<section class="section3 light-gray">
			<div class="section-inner">
				<h2 class="section-title">{{$t('stoPage.text5')}}</h2>
				<div class="spacer"></div>
				<div class="sto-key-function">
					<div class="sto-col">
						<div class="sto-title">{{$t('stoPage.text6')}}</div>
						<ul class="sto-bullet">
							<li>{{$t('stoPage.text7')}}</li>
							<li>{{$t('stoPage.text8')}}</li>
							<li>{{$t('stoPage.text9')}}</li>
							<li>{{$t('stoPage.text10')}}</li>
							<li>{{$t('stoPage.text11')}}</li>
							<li>{{$t('stoPage.text12')}}</li>
							<li>{{$t('stoPage.text13')}}</li>
							<li>{{$t('stoPage.text14')}}</li>
							<li>{{$t('stoPage.text15')}}</li>
						</ul>
					</div>
					<div class="sto-col">
						<ul class="sto-list">
							<li>
								<div class="title">{{$t('stoPage.text16')}}</div>
								<div class="subtitle">{{$t('stoPage.text17')}}</div>
							</li>
							<li>
								<div class="title">{{$t('stoPage.text18')}}</div>
								<div class="subtitle">{{$t('stoPage.text19')}}</div>
							</li>
							<li>
								<div class="title">{{$t('stoPage.text20')}}</div>
								<div class="subtitle">{{$t('stoPage.text21')}}</div>
							</li>
							<li>
								<div class="title">{{$t('stoPage.text22')}}</div>
								<div class="subtitle">{{$t('stoPage.text23')}}</div>
							</li>
							<li>
								<div class="title">{{$t('stoPage.text24')}}</div>
								<div class="subtitle">{{$t('stoPage.text25')}}</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>


		<section class="section3 white">
      <div class="section-inner">
        <h2 class="section-title">{{$t('stoPage.text26')}}</h2>
        <p>{{$t('stoPage.text27')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
	</div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
	name: 'STOPage',
	components: { BtnPrimary },
	data() {
		return {
			
		};
	},

	mounted() {
		
	},

	methods: {
		
	},
};
</script>

<style lang="scss" scoped>

</style>